import { useState } from "react";
const SkillsManager = ({skillList, setSkillList}) => {
  const [skills, setSkills] = useState("");
  const [skillsLevel, setSkillsLevel] = useState("Beginner");

  const skillLevels = ["Beginner", "Intermediate", "Expert", "Advanced", "Master"];

  const handleAddSkill = () => {
    const trimmedSkill = skills.trim();
    if (!trimmedSkill) return;
    if (skillList.some((item) => item.skill === trimmedSkill)) return;

    setSkillList([...skillList, { skill: trimmedSkill, level: skillsLevel }]);
    setSkills("");
    setSkillsLevel("Beginner");
  };

  const handleDeleteSkill = (skillToDelete) => {
    setSkillList(skillList.filter((item) => item.skill !== skillToDelete));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleAddSkill();
    }
  };

  return (
   <div className="flex flex-col mx-auto p-6 max-w-[900px] gap-6 font-sans">

  {/* Row 1: Skills / Tags */}
  <div className="flex items-start gap-4 md:flex-row flex-col">
    <div className="flex items-center gap-2 w-[30%] md:w-[30%] w-full">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <span className="text-gray-700 font-semibold text-base">Skills / Tags</span>
    </div>
    <input
      type="text"
      value={skills}
      onChange={(e) => setSkills(e.target.value)}
      placeholder="e.g., Problem Solving, Communication"
      onKeyPress={handleKeyPress}
      className="w-[70%] md:w-[70%] w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

  {/* Row 2: Skill Level */}
  <div className="flex flex-col items-start gap-3">
    <div className="flex items-center gap-2">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <span className="text-gray-700 font-semibold text-sm">Skill Level</span>
    </div>
    <div className="flex flex-wrap gap-3 w-full">
      {skillLevels.map((level) => (
        <button
          key={level}
          onClick={() => setSkillsLevel(level)}
          className={`flex-1 px-4 py-3 border-2 rounded-xl text-sm font-medium transition-all ${
            skillsLevel === level
              ? 'border-[#0f6abf] bg-[#e8f0f7] text-[#0f6abf]'
              : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50'
          }`}
        >
          {level}
        </button>
      ))}
    </div>
  </div>

  {/* Row 3: Add Skill button */}
  <div className="flex justify-start">
    <button
      onClick={handleAddSkill}
      className="px-6 py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-all flex items-center gap-2"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
      </svg>
      Add Skill
    </button>
  </div>

  {/* Skills List */}
  {skillList.length > 0 ? (
    <div className="space-y-2">
      {skillList.map((item, index) => (
        <div
          key={index}
          className="flex justify-between items-center bg-white p-4 border border-gray-200 rounded-xl hover:border-[#0f6abf] transition-all"
        >
          <div className="flex items-center gap-3">
            <span className="text-gray-900 font-medium text-sm">{item.skill}</span>
            <span
              className={`text-xs font-medium px-3 py-1.5 rounded-lg ${
                item.level.toLowerCase() === 'beginner'
                  ? 'bg-blue-50 text-blue-600 border border-blue-100'
                  : item.level.toLowerCase() === 'intermediate'
                  ? 'bg-yellow-50 text-yellow-600 border border-yellow-100'
                  : item.level.toLowerCase() === 'expert'
                  ? 'bg-green-50 text-green-600 border border-green-100'
                  : item.level.toLowerCase() === 'advanced'
                  ? 'bg-orange-50 text-orange-600 border border-orange-100'
                  : 'bg-purple-50 text-purple-600 border border-purple-100'
              }`}
            >
              {item.level}
            </span>
          </div>
          <button
            onClick={() => handleDeleteSkill(item.skill)}
            className="px-4 py-2 bg-red-50 text-red-600 border border-red-200 rounded-lg text-xs font-medium hover:bg-red-600 hover:text-white transition-colors"
          >
            Delete
          </button>
        </div>
      ))}
    </div>
  ) : (
    <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-700 mb-2">No skills added yet</h3>
      <p className="text-sm text-gray-500">Add your first skill using the form above</p>
    </div>
  )}

</div>
  );
};

export default SkillsManager;
